import { render, staticRenderFns } from "./SmsCodewordInstructions.vue?vue&type=template&id=197ae7ea&"
import script from "./SmsCodewordInstructions.vue?vue&type=script&lang=js&"
export * from "./SmsCodewordInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports